
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const menuItems = [
    { label: 'Resultados', path: '/resultados' },
    { label: 'Trajetória', path: '/trajetoria' },
    { label: 'Como Funciona', path: '/como-funciona' },
    { label: 'Sistema de Captação', path: '/sites-agente' },
    { label: 'Contato', path: '/contato' }
  ];

  return (
    <header className="shadow-sm sticky top-0 z-50" style={{ backgroundColor: '#f9f9f9' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/aa1326c90d527ffd18ec2db85b0a721b.png" 
              alt="7deOuros" 
              className="h-20 w-auto sm:h-24"
            />
          </Link>
          
          <nav className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'text-red-600'
                    : 'text-gray-700 hover:text-red-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20fazer%20uma%20an%C3%A1lise%20gratuita%20do%20meu%20funil%20de%20vendas.%20Quando%20podemos%20conversar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg"
            >
              Análise do Funil
            </a>
          </nav>
          
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-3">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`font-medium py-2 transition-colors duration-200 ${
                    location.pathname === item.path
                      ? 'text-red-600'
                      : 'text-gray-700 hover:text-red-600'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <div className="pt-2">
                <a
                  href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20fazer%20uma%20an%C3%A1lise%20gratuita%20do%20meu%20funil%20de%20vendas.%20Quando%20podemos%20conversar%3F"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg w-full"
                >
                  Análise do Funil
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
